/**
 * File scrollTrigger.js
 *
 * Handles triggering of scroll animations
 */

const config = {
    rootMargin: '-15% 0px',
    threshold: [ 0, 0.25, 0.75, 1 ],
};

const targets = document.querySelectorAll( '.animate-reveal' );

const observer = new IntersectionObserver( ( entries ) => {
    entries.forEach( ( entry ) => {
        if ( entry.intersectionRatio > 0 ) {
            entry.target.classList.add( 'animate' );
            observer.unobserve( entry.target ); // will animate only once
        } else {
            entry.target.classList.remove( 'animate' );
        }
    } );
}, config );

targets.forEach( ( target ) => {
    observer.observe( target );
} );

const hash = window.location.hash;

if ( hash ) {
    // If there's a hash in the URL, get the correspondent DOM element
    const targetEl = document.querySelector( hash );

    if ( targetEl ) {
        setTimeout( () => {
            // Add animate class to the target element children
            targetEl
                .querySelectorAll( '.animate-reveal' )
                .forEach( ( el ) => el.classList.add( 'animate' ) );

            // Call custom event for refreshing parallax components
            window.dispatchEvent( new Event( 'modop.rellax-refresh' ) );
        },
        300 );
    }
}
